import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-brand-hub',
  templateUrl: './whitelist-brand-hub.component.html',
  styleUrls: ['./whitelist-brand-hub.component.scss']
})
export class WhitelistBrandHubComponent implements OnInit {
  fileName: any = ''
  excel_file: any = ''
  page = 1
  Search: any = ''
  WhitelistListUser: any = []
  @Input() BrandHub_Created_ID: any = ''
  WhitlistResponse: any;
  uploadHidden: boolean = false
  getPaginationCount: any;
  brandHubdetails: any;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activateRoute: ActivatedRoute,
    private toast: ToastClientService,
    private xls: XlsxService,


  ) { }

  ngOnInit() {
    this.brandHubdetails = JSON.parse(localStorage.getItem("brandhubdeatails"))
    if (this.brandHubdetails.ModalName == "edit") {
      this.BrandHub_Created_ID = this.brandHubdetails.brandHubid
      this.getBrandDetailsOfUsersOnID(this.brandHubdetails.brandHubid)
    }
    console.log("Got brandHub Id from edited Component", this.BrandHub_Created_ID)
  }

  ngOnChanges() {
    console.log("Got brandHub Id from created Component", this.BrandHub_Created_ID)
  }

  downloadExcel() {
    let header = ["CSM Number", "Outlet Code"]
    this.exportExcelService.commonPrintHeaders1(header, "BrandHub_Whitelist_Users", 'Users')
  }


  importExcel(event) {
    this.fileName = event.target.files[0].name;
    this.excel_file = event.target.files[0]
  }

  upload() {
    const formData = new FormData()
    formData.append("excel_data", this.excel_file)
    formData.append("id", this.BrandHub_Created_ID)
    this.apiService.upload1(this.apiConfig.whitelistbrandHUsers, formData).subscribe((res: any) => {
      try {
        if (res.status == 200) {
          console.log(res)
          this.uploadHidden = true
          this.toast.Success("File Uploaded Succcessfully")
          this.WhitlistResponse = res.body.data
          this.excel_file = ''
          this.fileName = ""
          this.getBrandDetailsOfUsersOnID(this.BrandHub_Created_ID)
        }
      }
      catch {

      }
    }, err => {
      this.toast.Error("File Not Uploaded")
    })
  }

  DownloadRejectedRecords() {
    this.xls.export(this.WhitlistResponse.reject, "rejected_list")
  }

  getBrandDetailsOfUsersOnID(id) {
    this.apiService.getHeaders(this.apiConfig.getBrandHubWhiltestedUser + `?brand_hub_id=${id}&page=${this.page}&search=${this.Search}`).subscribe((res: any) => {
      console.log(res.body.data)
      console.log(res)
      this.WhitelistListUser = res.body.data
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count")
    })
  }

  toggleStatus(data) {
    console.log(data)
    let payload = {
      "id": this.BrandHub_Created_ID,
      // "flag" : 2,
      // 'user_id' : data.user_id
    }
    this.apiService.post(this.apiConfig.disableReward, payload)
      .subscribe((res: any) => {
        console.log(res)
        this.toast.Success(res.body.data.message)
        this.getBrandDetailsOfUsersOnID(this.BrandHub_Created_ID)
      })

  }

  filter() {
    this.getBrandDetailsOfUsersOnID(this.BrandHub_Created_ID)
  }

  reset() {
    this.Search = ''
    this.getBrandDetailsOfUsersOnID(this.BrandHub_Created_ID)
  }


  paginationClick(page) {
    this.page = page;
    this.getBrandDetailsOfUsersOnID(this.BrandHub_Created_ID)

  }

}
